declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch {
    // Analytics must never break the app.
  }
}

export function trackSignUp(method: string = 'clerk') {
  trackEvent('sign_up', { method });
}

export function trackPurchase(valueUsd: number, transactionId?: string) {
  trackEvent('purchase', {
    currency: 'USD',
    value: valueUsd,
    transaction_id: transactionId,
    items: [
      { item_id: 'pro_monthly', item_name: 'Tajweed Pro Monthly', price: valueUsd, quantity: 1 },
    ],
  });
}
